import baseApi from "~/common/services/base-api";

export const getOrders = async () => {
  const response = await baseApi.get(`/orders`);

  return response.data;
};
